<template>
  <div class="roulette__figure-wrap">
    <div
      v-if="!ready"
      class="spinner roulette__loading"
      role="status"
      aria-label="Loading"
    >
      <span class="sr-only">Loading...</span>
    </div>

    <div class="roulette__no-results" v-if="ready && collections.length === 0">
      <h2>Oops, no collections to display.</h2>
    </div>

    <transition name="fade">
      <figure
        v-if="ready && post"
        class="roulette__figure"
        :class="`roulette--${post.size}`"
      >
        <div class="roulette__media">
          <picture class="roulette__picture">
            <source :srcset="post.image.src.small" media="(max-width: 480px)" />
            <source
              :srcset="post.image.src.medium"
              media="(max-width: 768px)"
            />
            <b-img-lazy
              fluid
              blank-color="#dbe4e7"
              :src="post.image.src.large"
              class="roulette__image"
              :alt="post.image.alt"
            />
          </picture>

          <button
            v-if="collections.length > 1"
            class="roulette__button"
            title="Refresh"
            aria-label="Click to load a new item"
            @click="refresh"
          >
            <ahc-icon
              icon-name="shuffle-outline-mobile"
              icon-name-hover="shuffle-hover-mobile"
              colorHover="#fff"
              :focus-parent="true"
              width="40"
              height="40"
            >
              <span class="sr-only">Refresh</span>
            </ahc-icon>
            <ahc-icon
              icon-name="shuffle-outline"
              icon-name-hover="shuffle-hover"
              colorHover="#fff"
              :focus-parent="true"
              width="96"
              height="96"
            >
              <span class="sr-only">Refresh</span>
            </ahc-icon>
          </button>
        </div>

        <figcaption
          class="roulette__caption"
          :class="`roulette--${post.caption.background}`"
        >
          <h3 class="roulette__heading">
            <a v-if="post.caption.url" :href="post.caption.url" class="roulette__heading-link">
              {{ post.caption.heading }}
            </a>
            <span v-else>{{ post.caption.heading }}</span>
          </h3>
          <p class="roulette__description">{{ post.caption.description }}</p>
          <p v-if="post.caption.credit" class="roulette__credit">
            {{ post.caption.credit }}
          </p>
        </figcaption>
      </figure>
    </transition>
  </div>
</template>

<script lang="js">
  import ahcIcon from "../icon/icon.vue";
  import axios from 'axios';

  export default  {
    name: 'ahc-roulette',
    components: {
      ahcIcon,
    },
    props: {
      endpoint: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        collections: [],
        ready: false,
        post: null
      }
    },
    mounted () {
      this.fetchPosts();
    },
    methods: {
      fetchPosts() {
        const vm = this;

        axios
          .get(vm.endpoint)
          .then(response => {

            this.collections = response.data.items;

            this.post = this.collections[Math.floor(Math.random() * this.collections.length)];

            this.isFetching = false;
            vm.ready = true;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      refresh() {
        const vm = this;
        vm.ready = false;

        this.post = this.collections[Math.floor(Math.random() * this.collections.length)];

        this.$nextTick(() => {
          vm.ready = true;
        });
      }
    },
}
</script>

<style lang="scss">
@import "roulette";
</style>
